<template>
  <div class="news">
    <div class="news_hea">
      <myHeaderW></myHeaderW>
    </div>
    <div class="news_details">
      <div class="breadcrumb">
        <el-breadcrumb :separator-icon="ArrowRight">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/news' }"
            >新闻中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ data.dataSce.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news_details_html">
        <div class="news_details_title">
          <h1>{{ data.dataSce.title }}</h1>

          <p>
            <span>发稿时间：>{{ data.dataSce.createTime }}</span>
            <span>来源：{{ data.dataSce.intro || '超拼网' }}</span>
            <span>阅读：168次</span>
          </p>
        </div>
        <div v-html="data.dataSce.content"></div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import { ArrowRight } from "@element-plus/icons-vue";
import { reactive, ref, toRefs } from "@vue/reactivity";
import myHeaderW from "@/components/myHeaderW.vue";
import myFooter from "@/components/myFooter.vue";
import { useRoute } from "vue-router";
import { getrichTextdetails } from "@/comm/api";
import { onMounted,onUpdated } from "vue";

export default {
  components: {
    myHeaderW,
    myFooter,
  },
  setup() {
    let route = useRoute();

    const activeName = ref("0");
    let data = reactive({
      dataSce: {},
      ht: "11111111111111内容",
    });


    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    const getrichText = async () => {
      try {
        const res = await getrichTextdetails({ id: route.query.id });
        console.log(1, res);
        if (res.code == 1) {
          data.dataSce = res.data;
         
          let head = document.getElementsByTagName('head');
          let meta = document.createElement('meta');
          meta.name = 'keywords';
          meta.content = data.dataSce.title;
          head[0].appendChild(meta)
          document.title =  data.dataSce.title;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    onMounted(() => {
      getrichText();
    });
    return {
      data,
      activeName,
      handleClick,
      ArrowRight,
      getrichText,
    };
  },
};
</script>

<style lang="scss" scoped>
.news {
  background: #f5f5f5;
}

.news_hea {
  width: 100%;
  background: #fff;
}

.news_details {
  width: 1200px;
  margin: 0 auto;

  background: #fff;
  img {
    width: 100%;
  }
  .breadcrumb {
    padding: 40px;
  }

  .news_details_html {
    margin: 40px;
    margin-bottom: 0px;
    min-height: 800px;
  }

  .news_details_title {
    h1 {
      width: 480px;
      margin: 0 auto;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      text-align: center;
    }

    p {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 10px;
      color: #969696;
      border-bottom: 1px solid #cfcfcf;
      padding: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 30px;
    }
  }
}
</style>